import { Adapter } from "./adapter";
import { Injectable } from "@angular/core";

export class Salesman {
    public Salesman_ID: number = null;
    constructor(fields){
        return fields
    }
}

@Injectable()
export class SalesmanAdapter implements Adapter<Salesman> {
    adapt(item: any): Salesman {
        return new Salesman(item);
    }
}